import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { Component, h } from "preact";

interface IOptionItem {
  value: string;
  label: string;
}

interface IProps {
  label?: string;
  items: Array<string | IOptionItem>;
  onChange?: (newvalue: string) => void;
}

export const MultipleSelect = withWidgetConfiguration(
  class extends Component<IProps & IWidgetConfigurationProps> {
    public render(props: IProps & IWidgetConfigurationProps, state: {}) {
      return (
        <div class="form-group">
          {props.label ? <label>{props.label}</label> : null}
          <select
            class="form-control"
            multiple={true}
            onChange={(x: any) =>
              this.props.onChange
                ? this.props.onChange((x.target as HTMLInputElement).value)
                : null
            }
          >
            {props.items.map(this.renderItem)}
          </select>
        </div>
      );
    }

    private renderItem(item: string | IOptionItem) {
      if (typeof item === "string") {
        return <option>{item}</option>;
      } else {
        return <option value={item.value}>{item.label}</option>;
      }
    }
  }
);
